import { render, staticRenderFns } from "./EditCenterPoint.vue?vue&type=template&id=763c3f00&scoped=true&"
import script from "./EditCenterPoint.vue?vue&type=script&lang=ts&"
export * from "./EditCenterPoint.vue?vue&type=script&lang=ts&"
import style0 from "./EditCenterPoint.vue?vue&type=style&index=0&id=763c3f00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763c3f00",
  null
  
)

export default component.exports